
<div *ngIf="isLoading else loadedTemp" class="grid place-items-center w-full " style="height: calc(100vh - 228px)">
  <div class="w-full grid place-items-center">
    <mat-spinner [strokeWidth]="2" [diameter]="48"></mat-spinner>
    <div class="font-semibold mt-4">{{'labels.loading-data' | translate}}</div>
  </div>
</div>

<ng-template #loadedTemp>
  <cdk-virtual-scroll-viewport *ngIf="filteredVehicles?.length else emptyListTemp" itemSize="64" minBufferPx="128"
                               maxBufferPx="128" style="height: calc(100vh - 228px)" >
    <div *cdkVirtualFor="let vehicle of filteredVehicles" class="ml-4 mr-3 my-2 h-16" (click)="onSelect(vehicle)">
      <handovermod-vehicle-item [model]="vehicle" [isSelected]="isItemSelected(vehicle)"></handovermod-vehicle-item>
    </div>
  </cdk-virtual-scroll-viewport>
  <ng-template #emptyListTemp>
    <div *ngIf="!filteredVehicles?.length" class="grid place-items-center w-full " style="height: calc(100vh - 228px)">
      <div class="w-full">
        <div class="tk-i-no-vehicles w-full h-28"></div>
        <div class="font-semibold mt-5 text-center">{{'handover.no-vehicles-for-filter' | translate}}</div>
      </div>
    </div>
  </ng-template>
</ng-template>
